import { AlertTriangle } from 'lucide-react'
import { Button } from '@/components/ui/button'

export function ErrorFallback({ title = 'Something went wrong', message, requestId, onRetry }) {
  return (
    <div role="alert" className="mx-auto flex max-w-md flex-col items-center gap-4 px-6 py-20 text-center">
      <div className="flex size-12 items-center justify-center rounded-full bg-destructive/10 text-destructive">
        <AlertTriangle className="size-6" aria-hidden="true" />
      </div>
      <h1 className="text-xl font-semibold">{title}</h1>
      {message && <p className="text-muted-foreground">{message}</p>}
      {requestId && (
        <p className="text-xs text-muted-foreground">
          Reference: <code>{requestId}</code>
        </p>
      )}
      {onRetry && <Button onClick={onRetry}>Try again</Button>}
    </div>
  )
}
